import React from 'react';
import PropTypes from 'prop-types';
import { ProductContent } from 'DesignSystem/Typography';
import ElementWithTooltip from './ElementWithTooltip';

const ElementWithSimpleTextTooltip = ({
  children,
  className,
  displayEvent,
  placement,
  showByDefault,
  targetElement,
  targetClassName,
  tooltipHeader,
  tooltipId,
}) => (
  <ElementWithTooltip
    className={className}
    displayEvent={displayEvent}
    placement={placement}
    showByDefault={showByDefault}
    size="md"
    targetClassName={targetClassName}
    targetElement={targetElement}
    tooltipId={tooltipId}
  >
    <ProductContent
      className="ds-tooltip-default-header"
      variation="smallest"
    >
      {tooltipHeader}
    </ProductContent>
    <ProductContent
      className="ds-tooltip-default-text"
      variation="smallest"
    >
      {children}
    </ProductContent>
  </ElementWithTooltip>
);

ElementWithSimpleTextTooltip.defaultProps = {
  className: '',
  displayEvent: 'hover',
  placement: 'bottom',
  showByDefault: false,
  targetClassName: '',
};

ElementWithSimpleTextTooltip.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  displayEvent: PropTypes.oneOf([
    'hover',
    'click',
  ]),
  placement: PropTypes.oneOf([
    'bottom',
    'left',
    'right',
    'top',
  ]),
  showByDefault: PropTypes.bool,
  targetElement: PropTypes.node.isRequired,
  targetClassName: PropTypes.string,
  tooltipHeader: PropTypes.string.isRequired,
  tooltipId: PropTypes.string.isRequired,
};

export default ElementWithSimpleTextTooltip;



// WEBPACK FOOTER //
// ./src-react/DesignSystem/Tooltips/ElementWithDefaultTextTooltip.jsx